
export const stage_code = [
    "Nabitende Stage", 
    "Bugono Stage", 
    "Nawandala Stage", 
    "Namuliisi Stage", 
    "Itanda Stage"
]

export const subcounty_code = [
    "Makuutu", 
    "Nawandala"
]

export const reliability_code = [
    1, 
    2,
    3,
    4,
    5
]

export const district_code = [
    "Iganga"
]

export const boda_night = [
    "NEVER",
    "RARELY (1 NIGHT PER WEEK)",
    "ONLY SOMETIMES (2-4 NIGHTS PER WEEK)",
    "MOST OF THE TIME (5-6 NIGHTS PER WEEK)",
    "ALL OF THE TIME (7 NIGHTS PER WEEK)",
]

export const carrier = [
    "MTN",
    "Airtel",
    "Africell",
    "UTL",
    "Smile",
    "K2",
    "Other",
];


